import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { LocalStorageService } from '../../../../../../../core/services/localStorage.service';
import { AccountSelectionService } from './account-selection.service';
import { AuthService } from '@spartacus/core';

@Injectable()
export class AccountSelectionInterceptor implements HttpInterceptor {
  constructor(
    protected localStorageService: LocalStorageService,
    protected accountSelectionService: AccountSelectionService,
    private authService: AuthService,
  ) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // Does not add custom headers to requests to the authorization server.
    if (req.url.includes('/authorizationserver/')) {
      return next.handle(req);
    }

    const selectedAddressJSON: any = this.accountSelectionService.getAddressJson();
    const selectedAccountJSON: any = this.accountSelectionService.getAccountJson();
    const performCacheWarmup: boolean = this.accountSelectionService.isCacheWarmup();

    const selectedAddress = selectedAddressJSON ? JSON.parse(selectedAddressJSON) : selectedAddressJSON;
    const selectedAccount = selectedAccountJSON ? JSON.parse(selectedAccountJSON) : selectedAccountJSON;

    let clonedRequest = req;

    if (selectedAccount?.uid) {
      clonedRequest = clonedRequest.clone({
        headers: req.headers.set('selectedAccount', selectedAccount.uid),
      });
      if (performCacheWarmup) {
        clonedRequest = clonedRequest.clone({
          headers: clonedRequest.headers.set('cacheWarmup', 'true'),
        });
         this.localStorageService.setItem('cacheWarmup', 'false');
      }
    }

    if (selectedAddress?.uid) {
      clonedRequest = clonedRequest.clone({
        headers: clonedRequest.headers.set('selectedaddress', selectedAddress.uid),
      });
    }

    return next.handle(clonedRequest);
  }
}
